/** @license ISC License (c) copyright 2017 original and current authors */
/** @author Karthik Iyengar (karthikiyengar) */
/** @author Ian Hofmann-Hicks */

var pathEq = require('./pathEq')

module.exports =
  pathEq.origFn('propPathEq')
